import CONSTANTS, { RESPONSE_STATUS, CACHE } from '../utils/constants';
import { EVENT, log } from '../common/logger';
import { paymentConfirmation } from '../utils/formPost';
import { getKey, isFunction } from '../utils/common';
import WS from '../utils/websocket';
import { objectValues } from '../../../common/src/utils/common';

const _MAX_DELAY = 3000;
const _ITERATION = 3;

const parsePayload = response => {
  if (response && Object.prototype.hasOwnProperty.call(response, 'acquirementId')) {
    response.transId = response.acquirementId;
  }
  return response;
};

const _socketConfig = id => {
  return {
    url: `${CONSTANTS.QR.QR_HOST}${CONSTANTS.QR.WS}?DEVICE=web&ID=${id}`,
    retryInterval: count => {
      if (count >= _ITERATION) {
        return 'stop';
      }
      return _MAX_DELAY; // retry after 3 sec till websocket connection not established
    }
  };
};

const _getJoinRoomKey = cache => {
  const config = cache.getData(CACHE.MERCHANT_CONFIG) || {};
  const mId = cache.getData(CACHE.MID, '');
  const orderId = getKey(config, 'data.orderId');

  return `${mId}_${orderId}`;
};

const checkTransactionStatus = cache => {
  paymentConfirmation(cache);
};

const expire = cache => {
  cache.getData(CACHE.STORE).setState({ sessionExpired: true });
};

let _priorSocket;
let _isConnected = false;
let _queuedOptions = {};

const initSocket = (qr, options, cache, instanceKey) => {
  let socket;
  const joinRoom = _getJoinRoomKey(cache);
  _queuedOptions[instanceKey] = options;

  try {
    if (_priorSocket) {
      if (_isConnected) {
        isFunction(getKey(options, 'connect')) && options.connect();
      }
      socket = _priorSocket;
    } else {
      socket = WS(_socketConfig(joinRoom));
    }
  } catch (error) {
    log({ eventType: EVENT.WS_INIT_ERROR, error });
    return null;
  }

  if (!_priorSocket) {
    socket.on('open', () => {
      _isConnected = true;
      objectValues(_queuedOptions).forEach(instanceOptions => {
        isFunction(getKey(instanceOptions, 'connect')) && instanceOptions.connect();
      });
      socket.emit('JOIN_ROOMS', joinRoom);

      log({ eventType: EVENT.JOIN_ROOM, room: joinRoom });

      socket.on(joinRoom, response => {
        const output = {
          response: {},
          showPRN: false,
          hideQR: false,
          showProcessing: false
        };

        try {
          const parsedQrResponse = parsePayload(response);
          output.response = parsedQrResponse;
          log({
            eventType: EVENT.QR_STATUS,
            status: parsedQrResponse.status
          });

          if (parsedQrResponse) {
            if (parsedQrResponse.status === RESPONSE_STATUS.PROCESSING) {
              log({ eventType: EVENT.QR_PROCESSING });
              output.showProcessing = true;
            } else if (parsedQrResponse.status === RESPONSE_STATUS.SUCCESS) {
              log({ eventType: EVENT.QR_SUCCESS });
              output.hideQR = true;
              if (qr.prn) {
                // prn screen shown
                log({ eventType: EVENT.PRN_FLOW });
                output.showPRN = true;
                output.timeout = true;
                output.showProcessing = false;
                socket.close();
              } else {
                checkTransactionStatus(cache);
              }
            } else if (parsedQrResponse.status === RESPONSE_STATUS.FAIL) {
              log({ eventType: EVENT.QR_FAIL });
              output.hideQR = true;
              checkTransactionStatus(cache);
            } else if (parsedQrResponse.status === RESPONSE_STATUS.REDIRECT) {
              output.isPending = true;
            }
          }
        } catch (e) {
        } finally {
          objectValues(_queuedOptions).forEach(instanceOptions => {
            isFunction(getKey(instanceOptions, 'roomListener')) &&
              instanceOptions.roomListener(output);
          });
        }
      });
    });

    socket.on('close', data => {
      try {
        const instanceKey = getKey(data, 'reason');
        const processOptions = instanceKey
          ? { [instanceKey]: _queuedOptions[instanceKey] }
          : _queuedOptions;

        Object.keys(processOptions).forEach(key => {
          const instanceOptions = _queuedOptions[key];
          if (instanceOptions) {
            isFunction(getKey(instanceOptions, 'disconnect')) && instanceOptions.disconnect();
            isFunction(getKey(instanceOptions, 'reload')) && instanceOptions.reload(true);
            delete _queuedOptions[key];
          }
        });

        if (!Object.keys(_queuedOptions).length) {
          _isConnected = false;
          _priorSocket = null;
          _queuedOptions = {};
          socket.close();
        }
      } catch (ex) {}
    });

    socket.on('error', () => {
      log({
        eventType: EVENT.QR_ERROR,
        message: 'unable to connect to websocket server'
      });
    });

    _priorSocket = socket;
  }

  return socket;
};

const attachEvents = (qr, cache) => {
  let timeout = null;
  if (qr.pageTimeout) {
    timeout = setTimeout(() => {
      log({ eventType: EVENT.QR_SESSION_TIMEOUT });
      expire(cache);
    }, qr.pageTimeout);
  }
  return timeout;
};

const qr = {
  attachEvents,
  expire,
  checkTransactionStatus,
  initSocket,
  parsePayload
};

export default qr;



// WEBPACK FOOTER //
// ./controllers/qr.js